import { makeAutoObservable } from "mobx";
import { AttributeShelf, LoaderShelf } from "../../../shelves";
import { api } from "../../../services";
import type { AuthenticationStore } from "../../../stores";
import type { ReasonsCode } from "../../../enum";
import { DocumentosCopyBiometryAnalysisStatus, KYCBiometryAnalysisStatus, StatusFraudAnalysis } from "../../../enum";

export class Store {
	public loader = new LoaderShelf();
	public status = new AttributeShelf<ReasonsCode | StatusFraudAnalysis>(StatusFraudAnalysis.PENDING);

	constructor(public authentication: AuthenticationStore) {
		makeAutoObservable(this);
	}

	public get getStatus(): ReasonsCode | StatusFraudAnalysis {
		return this.status.value;
	}

	public fetchStatus = async (): Promise<void> => {
		if (this.loader.isLoading) {
			return;
		}

		this.loader.start();

		try {
			const {
				data: { documentoscopy, kyc },
			} = await api.getFraudAnalysis(this.authentication.getToken() || "");
			if (
				documentoscopy.status === DocumentosCopyBiometryAnalysisStatus.APPROVED &&
				kyc.status === KYCBiometryAnalysisStatus.APPROVED
			) {
				this.status.set(StatusFraudAnalysis.APPROVED);
				return;
			}

			if (
				documentoscopy.status === DocumentosCopyBiometryAnalysisStatus.DISAPPROVED ||
				kyc.status === KYCBiometryAnalysisStatus.REPROVED ||
				kyc.status === KYCBiometryAnalysisStatus.DISAPPROVED
			) {
				this.status.set(StatusFraudAnalysis.DISAPPROVED);
				return;
			}

			if (documentoscopy.status === DocumentosCopyBiometryAnalysisStatus.RESEND_NEEDED) {
				if (documentoscopy.reasonsCode) {
					this.status.set(documentoscopy.reasonsCode[0].code);
					return;
				} else {
					this.status.set(StatusFraudAnalysis.RESEND_NEEDED);
					return;
				}
			}

			this.status.set(StatusFraudAnalysis.PENDING);
		} catch (e) {
			window.console.error(e);
			return;
		} finally {
			this.loader.end();
		}
	};
}
